// All user related database operations can be defined here.

import http from "../http-common";

class UserDataService {
  doLogin(model: ILoginRequestModel) {
    return http.post(`user/login`, model);
  }
  getUser(userId: string) {
    return http.get(`user/` + userId);
  }
  getFavourites(userId: string) {
    return http.get(`user/favourites?id=` + userId);
  }
  favourite(userId: string, contentId: string) {
    return http.post(`user/${userId}/${contentId.replace('-','')}/favourite`);
  }
  unfavourite(userId: string, contentId: string) {
    return http.post(`user/${userId}/${contentId.replace('-','')}/unfavourite`);
  }
}


export interface ILoginRequestModel {
  uniqueCode: string
  uniqueCodeReentered: string
}


const datservice = new UserDataService();

export default datservice;
